import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';
 
export const clearCart = (id, storeId) => {
  return axios({
    method: 'delete',
    url:
      STORE_BASE_URL +
      '/store/api/secure/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/cart', // for android use
    headers: getHeaders(),
  });
};
